// import React from 'react'

// const DataTableFooter = ( {dataT} ) => {
//   return (
//     <div className="d-flex justify-content-between align-items-center">
//         <div>
//           Showing 1 to{' '} {dataT.length} of {dataT.length} entries
//         </div>
//         <div className="dataTables_paginate paging_simple_numbers" id="timetracker-table_paginate">
//           <ul className="pagination">
//             <li className="paginate_button page-item previous disabled" id="timetracker-table_previous">
//               <a href="#" aria-controls="timetracker-table" data-dt-idx="0" tabIndex="0" className="page-link">Previous</a>
//             </li>
//             <li className="paginate_button page-item active">
//               <a href="#" aria-controls="timetracker-table" data-dt-idx="1" tabIndex="0" className="page-link text-white">1</a>
//             </li>
//             <li className="paginate_button page-item next disabled" id="timetracker-table_next">
//               <a href="#" aria-controls="timetracker-table" data-dt-idx="2" tabIndex="0" className="page-link">Next</a>
//             </li>
//           </ul>
//         </div>
//     </div>
//   )
// }

// export default DataTableFooter

import React from "react";

const DataTableFooter = ({
  pageIndex,
  pageCount,
  canNextPage,
  canPreviousPage,
  nextPage,
  previousPage,
  gotoPage,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center py-2">

      {/* Info */}
      <div>
        Page <strong>{pageIndex + 1}</strong> of {pageCount}
      </div>

      {/* Pagination */}
      <ul className="pagination mb-0">

        {/* Previous */}
        <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => previousPage()}>
            Previous
          </button>
        </li>

        {/* Page Numbers */}
        {Array.from({ length: pageCount }).map((_, i) => (
          <li
            key={i}
            className={`page-item ${pageIndex === i ? "active" : ""}`}
          >
            <button className="page-link" onClick={() => gotoPage(i)}>
              {i + 1}
            </button>
          </li>
        ))}

        {/* Next */}
        <li className={`page-item ${!canNextPage ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => nextPage()}>
            Next
          </button>
        </li>
      </ul>
    </div>
  );
};

export default DataTableFooter;

// import React from "react";
// import "./datefooter.css";

// const DataTableFooter = ({
//   pageIndex,
//   pageCount,
//   canNextPage,
//   canPreviousPage,
//   nextPage,
//   previousPage,
//   gotoPage,
// }) => {
//   const visiblePages = () => {
//     const total = pageCount;
//     const current = pageIndex + 1;
//     const delta = 3; // number of pages to show around current page
//     const range = [];

//     for (
//       let i = Math.max(1, current - delta);
//       i <= Math.min(total, current + delta);
//       i++
//     ) {
//       range.push(i);
//     }

//     // Add first page if not in range
//     if (range[0] > 1) {
//       if (range[0] > 2) range.unshift("...");
//       range.unshift(1);
//     }

//     // Add last page if not in range
//     if (range[range.length - 1] < total) {
//       if (range[range.length - 1] < total - 1) range.push("...");
//       range.push(total);
//     }

//     return range;
//   };

//   return (
//     <div className="d-flex justify-content-center align-items-center py-3 border-top">
//       <div className="d-flex align-items-center flex-wrap gap-3">
//         {/* Info */}
//         <div className="fw-semibold me-3 text-muted small">
//           Page <span className="fw-bold text-dark">{pageIndex + 1}</span> of{" "}
//           <span className="fw-bold text-dark">{pageCount}</span>
//         </div>

//         {/* Pagination */}
//         <ul className="pagination mb-0 shadow-sm rounded overflow-hidden">
//           {/* Previous */}
//           <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`}>
//             <button
//               className="page-link text-info fw-semibold"
//               onClick={() => previousPage()}
//               disabled={!canPreviousPage}
//             >
//               Previous
//             </button>
//           </li>

//           {/* Page Numbers */}
//           {visiblePages().map((num, i) =>
//             num === "..." ? (
//               <li key={i} className="page-item disabled">
//                 <span className="page-link text-muted">...</span>
//               </li>
//             ) : (
//               <li
//                 key={num}
//                 className={`page-item ${pageIndex + 1 === num ? "active" : ""}`}
//               >
//                 <button
//                   className="page-link fw-semibold"
//                   onClick={() => gotoPage(num - 1)}
//                 >
//                   {num}
//                 </button>
//               </li>
//             )
//           )}

//           {/* Next */}
//           <li className={`page-item ${!canNextPage ? "disabled" : ""}`}>
//             <button
//               className="page-link text-info fw-semibold"
//               onClick={() => nextPage()}
//               disabled={!canNextPage}
//             >
//               Next
//             </button>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default DataTableFooter;
